import React from "react";
import { motion } from "framer-motion";

export default function Contact() {
  return (
    <div className="w-full text-gray-800 font-sans">

      {/* ================= HERO ================= */}
      <motion.section
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        className="bg-gradient-to-r from-blue-900 via-blue-800 to-blue-700 text-white py-28 px-6"
      >
        <div className="max-w-6xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold mb-8">
            Let’s Discuss Your Requirements
          </h1>

          <p className="text-lg md:text-xl text-blue-100 max-w-3xl leading-relaxed">
            Whether you are exploring corporate training, enterprise IT
            solutions, or long-term technology consulting, our team will work
            with you to understand your objectives and design the right
            engagement model.
          </p>
        </div>
      </motion.section>

      {/* ================= CONTACT CONTENT ================= */}
      <section className="py-28 px-6 bg-white">
        <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-20">

          {/* LEFT — CONTEXT */}
          <div>
            <h2 className="text-3xl font-bold mb-6">
              How We Engage
            </h2>

            <p className="text-gray-600 mb-6 leading-relaxed">
              At TechX Incorporation, every engagement begins with a structured
              discussion. We focus on understanding your business context,
              existing technology landscape, team maturity, and long-term
              objectives before proposing any solution or training program.
            </p>

            <p className="text-gray-600 mb-6 leading-relaxed">
              Our consultants typically engage with enterprise stakeholders
              across engineering, architecture, learning & development, and
              leadership teams to ensure alignment and measurable outcomes.
            </p>

            <div className="mt-10">
              <h3 className="font-semibold text-lg mb-2">
                Contact Information
              </h3>
              <p className="text-gray-600">
                Email:{" "}
                <a
                  href="mailto:finance@techxincorporation.com"
                  className="text-blue-700 font-medium hover:underline"
                >
                  finance@techxincorporation.com
                </a>
              </p>
            </div>
          </div>

          {/* RIGHT — FORM */}
          <div className="bg-gray-50 rounded-2xl p-10 shadow-sm">
            <h3 className="text-2xl font-semibold mb-6">
              Request a Consultation
            </h3>

            <form className="space-y-6">
              <div>
                <label className="block text-sm font-medium mb-2">
                  Full Name
                </label>
                <input
                  type="text"
                  className="w-full border border-gray-300 rounded-lg px-4 py-3
                             focus:outline-none focus:ring-2 focus:ring-blue-600"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-2">
                  Work Email
                </label>
                <input
                  type="email"
                  className="w-full border border-gray-300 rounded-lg px-4 py-3
                             focus:outline-none focus:ring-2 focus:ring-blue-600"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-2">
                  Organization
                </label>
                <input
                  type="text"
                  className="w-full border border-gray-300 rounded-lg px-4 py-3
                             focus:outline-none focus:ring-2 focus:ring-blue-600"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-2">
                  Area of Interest
                </label>
                <select
                  className="w-full border border-gray-300 rounded-lg px-4 py-3
                             focus:outline-none focus:ring-2 focus:ring-blue-600"
                >
                  <option>Corporate Training</option>
                  <option>Enterprise IT Solutions</option>
                  <option>Technology Consulting</option>
                  <option>Combination / Not Sure</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium mb-2">
                  Brief Description of Requirements
                </label>
                <textarea
                  rows="4"
                  className="w-full border border-gray-300 rounded-lg px-4 py-3
                             focus:outline-none focus:ring-2 focus:ring-blue-600"
                />
              </div>

              <button
                type="submit"
                className="w-full bg-blue-700 text-white py-3 rounded-lg
                           font-semibold hover:bg-blue-800 transition"
              >
                Submit Request
              </button>
            </form>
          </div>
        </div>
      </section>

    </div>
  );
}
